import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { BottomCTA } from 'components/Accommodation/Offers/BottomCTA';
import { reviewMessages } from 'components/Reviews/ReviewMessages';
import { getGuestReviewsOverlayVisibility } from 'modules/overlay/selectors';
import { hideOverlay } from 'modules/overlay/slice';
import { toggle } from 'opticks';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { OverlayPage, OverlayPageContent, OverlayPageFooter } from '@daedalus/atlas/OverlayPage';
import { PopUp } from '@daedalus/atlas/PopUp';
import { Text } from '@daedalus/atlas/Text';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src';
import { ConditionalReviews } from '../AccommodationView/Mobile/ConditionallyRenderedSections/ConditionalReviews';
import { GuestReviewLayout } from '../ReviewsSection/constants';
interface Props {
  hotel: ContentHotel | undefined;
}
const _exp = /*#__PURE__*/() => Text;
const HeaderText = /*#__PURE__*/styled(_exp())({
  name: "HeaderText",
  class: "h1sijub",
  propsAsIs: true
});
const TitleBarContent = () => {
  const {
    formatMessage
  } = useIntl();
  return <HeaderText variant="titleM" align="center">
      {toggle('9633c72c-guest-reviews-sort-filter', formatMessage(reviewMessages.reviews), formatMessage(reviewMessages.guestReviews))}
    </HeaderText>;
};
export const GuestReviewsOverlayPage = ({
  hotel
}: Props) => {
  const {
    isDesktop
  } = useDeviceLayout();
  const dispatch = useDispatch();
  const isOpen = useSelector(getGuestReviewsOverlayVisibility);
  useEffect(() => {
    if (isOpen) dispatch(trackEvent({
      category: Category.User,
      entity: Entity.ReviewDetails,
      action: Action.Viewed
    }));
  }, [dispatch, isOpen]);
  const onClose = () => {
    dispatch(hideOverlay());
  };
  if (isDesktop) return <PopUp width={1000} isOpen={isOpen} closeAction={onClose} titleBarProps={{
    centerContent: <TitleBarContent />,
    hasDivider: true
  }}>
        <ConditionalReviews hotel={hotel} layoutConfig={GuestReviewLayout.FULL} mountedOnOverlay />
      </PopUp>;
  return <OverlayPage titleBarProps={{
    centerContent: <TitleBarContent />
  }} isOpen={isOpen} onClose={onClose} dataId="guestReviewsOverlayContent">
      <OverlayPageContent>
        <ConditionalReviews hotel={hotel} layoutConfig={GuestReviewLayout.FULL} mountedOnOverlay />
      </OverlayPageContent>
      <OverlayPageFooter>
        <BottomCTA hotelId={hotel?.objectID} sourceComponent="MobileHotelGuestReviewsTopOfferCTA" />
      </OverlayPageFooter>
    </OverlayPage>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");